import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import useAuthStore from './store/useAuthStore';
import useLayoutStore from './store/useLayoutStore';
import LoadingSpinner from './components/elements/LoadingSpinner';

import LoginPage from './routes/LoginPage';
import UserPage from './routes/UserPage';
import AdminPage from './routes/AdminPage';

const App = () => {
    const userRole = useAuthStore(state => state.userRole);
    const loading = useAuthStore(state => state.loading);
    const checkSession = useAuthStore(state => state.checkSession);
    const isDarkTheme = useLayoutStore(state => state.isDarkTheme);
    const landingUrl = import.meta.env.VITE_LANDING_URL;
    const appBasename = import.meta.env.VITE_APP_BASENAME;

    useEffect(() => {
        checkSession();
    }, [checkSession]);

    if (loading) {
        const loginBackgroundImage = isDarkTheme ? '/login/bgBlack3.webp' : '/login/bgLight.webp';
        const loginBackgroundColor = isDarkTheme ? '#0f1117' : '#f4f6fb';

        return (
            <div
                className="app-container-login"
                style={{
                    backgroundImage: `url("${loginBackgroundImage}")`,
                    backgroundColor: loginBackgroundColor,
                    position: 'relative'
                }}
            >
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <BrowserRouter basename={appBasename}>
            <Routes>
                <Route path="/" element={<ExternalRedirect to={landingUrl} />} />
                <Route path="/login" element={userRole ? <Navigate to={`/${userRole}`} /> : <LoginPage />} />
                {/* <Route path='/login' element={<LoginPage />} /> */}
                <Route path="/user" element={
                    <ProtectedRoute>
                        <UserPage />
                    </ProtectedRoute>
                } />
                <Route path="/admin" element={
                    <ProtectedRoute roles={['admin']}>
                        <AdminPage />
                    </ProtectedRoute>
                } />
            </Routes>
        </BrowserRouter>
    )
}

export default App;

const ProtectedRoute = ({ children, roles = ['user', 'admin'] }) => {
    const { userRole } = useAuthStore();

    if (!userRole) return <Navigate to="/login" replace />;
    if (!roles.includes(userRole)) return <Navigate to="/" replace />;
    return children;
};

const ExternalRedirect = ({ to }) => {
    useEffect(() => {
        window.location.replace(to);
    }, [to]);

    return null;
};
